import React, { Component } from "react";
import "../Styles/SvgCommand.css";

const ErrorIcon = (props) => {
  return (
  <svg version="1.1" x="0px" y="0px" height="20px" width="20px"
	   viewBox="0 0 50 50" style={{enableBackground:"new 0 0 50 50"}} >
    <circle style={{fill:"#D75A4A"}} cx="25" cy="25" r="25"/>
    <polyline style={{fill:"none",stroke:"#FFFFFF",strokeWidth:5,strokeLinecap:"round",strokeMiterlimit:10}} 
      points="16,34 25,25 34,16 "/>
    <polyline style={{fill:"none",stroke:"#FFFFFF",strokeWidth:5,strokeLinecap:"round",strokeMiterlimit:10}} 
      points="16,16 25,25 34,34 "/>
  </svg>

  );
};

export default ErrorIcon;
